export const isCmdClickEvent = <T>(event: React.MouseEvent<T>): boolean => {
  const isMac = window.navigator.platform.includes('Mac')
  return (isMac && event.metaKey) || (!isMac && event.ctrlKey)
}
